const positions = [
  { top: "12vh", left: "var(--space-lg)" },
  { top: "12vh", right: "var(--space-lg)" },
  { bottom: "12vh", left: "var(--space-lg)" },
  { bottom: "12vh", right: "var(--space-lg)" },
] as const;

export function HUDCrosshairs() {
  return (
    <>
      {positions.map((pos, i) => (
        <div
          key={i}
          aria-hidden="true"
          style={{
            position: "fixed",
            width: 20,
            height: 20,
            zIndex: 90,
            pointerEvents: "none",
            ...pos,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 9,
              left: 0,
              width: "100%",
              height: 1,
              background: "var(--fog)",
              opacity: 0.4,
            }}
          />
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 9,
              width: 1,
              height: "100%",
              background: "var(--fog)",
              opacity: 0.4,
            }}
          />
        </div>
      ))}
    </>
  );
}
